import React, {useState} from 'react';
import { Helmet } from "react-helmet";
import {Header, Titulo, ContenedorBotones} from '../elementos/Header';
import BtnRegresar from "../elementos/BtnRegresar";
import {ContenedorDoble, Lista, ElementoLista, Descripcion,  BotonAccion, ContenedorBotonCentral, 
    BotonCargarMas, ContenedorSubtitulo, Subtitulo} from './../elementos/ElementosClientes';
import useObtenerClientes from './../hooks/useObtenerClientes';
import { ReactComponent as IconoEditar } from './../imagenes/editar.svg';
import IconoEstadoConductor from './../elementos/IconoEstadoConductor'
import FormularioEditarCliente from "./FormularioEditarCliente";
import FormularioCreaCliente from "./FormularioCreaCliente";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faIdCard,faPhone,faEnvelope} from '@fortawesome/free-solid-svg-icons';    

const  Clientes = () => {
    const clientes = useObtenerClientes();
    clientes.sort((a, b) => (a.nombrecorto > b.nombrecorto ? 1 : a.nombrecorto < b.nombrecorto ? -1 : 0))
    const [cliente, CambiarCliente] = useState({});
    const [estadoEditar, CambiarEstadoEditar] = useState(true);
    const [estadoCrear, CambiarEstadoCrear] = useState(false);

    
const EditarCliente = (cliente) => {  
      CambiarEstadoCrear(true)
      CambiarEstadoEditar(false)
      CambiarCliente(cliente)
  }
    


    return ( 
        <>
        <Helmet>
        <title>Clientes</title>
        </Helmet>
            <Header>
                <BtnRegresar></BtnRegresar>
                <Titulo>Clientes</Titulo>         
            </Header>
        <ContenedorDoble>
        
        <Lista>
        <ContenedorSubtitulo><Subtitulo>Listado de Clientes</Subtitulo></ContenedorSubtitulo>
          {clientes.map((cliente,index) => {
               
               return(
               <div key={cliente.id}>
                
                <ElementoLista key={cliente.id}>

                    <Descripcion><IconoEstadoConductor estado={cliente.estado}/>&nbsp;{cliente.nombrecorto}&nbsp;</Descripcion>
                    <Descripcion><FontAwesomeIcon icon={faIdCard}/>&nbsp;{cliente.nombre}</Descripcion>
                    <Descripcion><FontAwesomeIcon icon={faPhone}/>&nbsp;{cliente.telefono}</Descripcion>
                    <Descripcion><FontAwesomeIcon icon={faEnvelope}/>&nbsp;{cliente.correo}</Descripcion>
                    <ContenedorBotones><BotonAccion onClick={(e) => {
                                                e.preventDefault()
                                                EditarCliente(cliente)}}>
                        <IconoEditar/>
                      </BotonAccion>
                    </ContenedorBotones>
                </ElementoLista>
                </div>)
          
          })}

            <ContenedorBotonCentral>
              <BotonCargarMas>Cargar Más</BotonCargarMas>
            </ContenedorBotonCentral>

            </Lista> 
            <div>
            <div hidden={estadoCrear}>
        <FormularioCreaCliente 
          estadoCrear={estadoCrear} 
          CambiarEstadoCrear={CambiarEstadoCrear}/>
            </div>
            
            <div hidden={estadoEditar}>
        <FormularioEditarCliente 
            cliente={cliente} 
            estadoEditar={estadoEditar} 
            CambiarEstadoEditar={CambiarEstadoEditar}/> 
            </div>
            </div>
        </ContenedorDoble>
        
        </>
     );
}
 
export default  Clientes;